<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <!--GIS全览图 工具类地图选择 -->
  <a-select v-model="mapTypeName" style="width: 160px" @change="handleChange">
    <a-select-option value="高德地图">
      高德地图
    </a-select-option>
    <a-select-option value="必应地图">
      必应地图
    </a-select-option>
    <a-select-option value="影像地图-天地图">
      影像地图-天地图
    </a-select-option>
    <a-select-option value="影像地图-ArcGis地图">
      影像地图-ArcGis地图
    </a-select-option>
    <a-select-option value="影像地图-高德地图">
      影像地图-高德地图
    </a-select-option>
    <!-- <a-select-option value="地形图层" @click="handleSelect">
      地形图层-自定义
      <a-icon type="check" v-if="isShow" style="font-size: 14px;margin-left: 5px;" />
    </a-select-option> -->
  </a-select>
</template>

<script>
import TileLayer from 'ol/layer/Tile'
import XYZ from 'ol/source/XYZ'
import * as olProj from 'ol/proj'
import ImageWMS from 'ol/source/ImageWMS'
import ImageLayer from 'ol/layer/Image'
export default {
  props: {
    mapType: {
      type: String,
      default: '高德地图'
    }
  },
  data () {
    return {
      mapTypeName: this.mapType,
      isShow: false,
      // 天地图影像
      tdtHttpUrl: `http://t7.tianditu.com/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=bbb8e87c166f332a270fa223ba022abb `,
      tdtHttpsUrl: `https://t7.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=bbb8e87c166f332a270fa223ba022abb `,
      //ArcGis地图
      arcgisUrl: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      //高德地图
      gaodeUrl: 'https://webst01.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}',
      //谷歌地图影像 m 路线图、t 地形图、p 带标签的地形图、s 卫星图、y 带标签的卫星图、h 标签层（路名、地名等）
      xdtUrl1: 'https://gac-geo.googlecnapps.cn/maps/vt?lyrs=y,m&gl=&x={x}&y={y}&z={z}',
      xdtUrl2: 'https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s@815&gl=CN&hl=zh-CN&x={x}&y={y}&z={z}',

      tdUrl: 'http://t7.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2217db4d2cabf0ad3f9c0d8b29a85498'
    }
  },
  methods: {
    init (value) {
      console.log('zhu->mapType->init', value)
      const gcj02Extent = [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244]
      const gcjMecator = new olProj.Projection({ code: 'GCJ-02', extent: gcj02Extent, units: 'm' })
      olProj.addProjection(gcjMecator)
      olProj.addCoordinateTransforms('EPSG:4326', gcjMecator, window.projzh.ll2gmerc, window.projzh.gmerc2ll)
      olProj.addCoordinateTransforms('EPSG:3857', gcjMecator, window.projzh.smerc2gmerc, window.projzh.gmerc2smerc)
      const mapLayer = this.loadingMap(value, gcjMecator)
      this.$parent.addLayer(mapLayer)
      mapLayer.values_.opacity = this.$parent.$refs.mapAlphas.alphaValue
    },
    handleSelect () {
      if (this.isShow) {
        this.$parent.removeLayerByName('water_custom_wms_layers')
      } else {
        this.loadingWmsLayer()
      }
      this.isShow = !this.isShow
    },
    handleChange (value) {
      if (value !== '地形图层') {
        this.$parent.removeLayerByName('底图')
        this.init(value)
      }
    },
    loadingWmsLayer () {
      console.log('zhu->loadingWmsLayer')
      const params = { LAYERS: 'water_custom_wms_layers:custom', FORMAT: 'image/png' }
      const wmsSource = new ImageWMS({
        crossOrigin: 'anonymous',
        params,
        serverType: 'geoserver',
        url: `/api/geoserver/water_custom_wms_layers/wms`
      })
      const wmsLayer = new ImageLayer({
        name: 'water_custom_wms_layers',
        crossOrigin: 'anonymous',
        // projection: 'EPSG:4490',
        projection: 'EPSG:4326',
        source: wmsSource,
        zIndex: 99
      })
      wmsLayer.setVisible(true)
      this.$parent.addLayer(wmsLayer)
    },
    loadingMap (value, gcjMecator) {
      let mapLayer
      if (value === '高德地图') {
        mapLayer = new TileLayer({
          name: '底图',
          title: '高德地图',
          source: new XYZ({
            projection: gcjMecator,
            crossOrigin: 'anonymous',
            url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}'
          })
        })
        this.$parent.setMaxZoom(25)
      } else if (value === '天地图') {
        mapLayer = new TileLayer({
          name: '底图',
          title: '天地图底图',
          source: new XYZ({
            crossOrigin: 'anonymous',
            projection: 'EPSG:3857',
            url: 'http://t4.tianditu.com/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=2217db4d2cabf0ad3f9c0d8b29a85498'
          })
        })
        this.$parent.setMaxZoom(18)
      } else if (value === '影像地图-天地图') {
        mapLayer = new TileLayer({
          name: '底图',
          title: '影像地图-天地图',
          source: new XYZ({
            crossOrigin: 'anonymous',
            projection: 'EPSG:3857',
            url: localStorage.getItem('env') === '生产' ? this.tdtHttpsUrl : this.tdtHttpsUrl
          })
        })
        this.$parent.setMaxZoom(18)
      } else if (value === '必应地图') {
        mapLayer = new TileLayer({
          name: '底图',
          source: new XYZ({
            projection: gcjMecator,
            crossOrigin: 'anonymous',
            tileUrlFunction: this.tileUrlFunction
          })
        })
        this.$parent.setMaxZoom(25)
      } else if (value === '腾讯地图') {
        mapLayer = new TileLayer({
          name: '底图',
          title: '高德地图',
          source: new XYZ({
            projection: gcjMecator,
            crossOrigin: 'anonymous',
            url: 'http://rt0.map.gtimg.com/realtimerender?z={z}&x={x}&y={-y}&type=vector&style=0'
          })
        })
        this.$parent.setMaxZoom(18)
      } else if (value === '影像地图-ArcGis地图') {
        mapLayer = new TileLayer({
          name: '底图',
          title: '影像地图-ArcGis地图',
          source: new XYZ({
            projection: 'EPSG:3857', // 'EPSG:3857',
            crossOrigin: 'anonymous',
            url: this.arcgisUrl
          })
        })
        this.$parent.setMaxZoom(18)
      } else if (value === '影像地图-高德地图') {
        mapLayer = new TileLayer({
          name: '底图',
          title: '影像地图-高德地图',
          source: new XYZ({
            projection: gcjMecator, // 'EPSG:3857',
            crossOrigin: 'anonymous',
            url: this.gaodeUrl
          })
        })
        this.$parent.setMaxZoom(16)
      }

      return mapLayer
    },
    tileUrlFunction (coord, params1, params2) {
      return this.getVETileUrl(coord[0], coord[1], coord[2])
    },
    getVETileUrl (z, x, y) {
      for (var a = '', c = x, d = y, e = 0; e < z; e++) {
        a = ((c & 1) + 2 * (d & 1)).toString() + a
        c >>= 1
        d >>= 1
      }
      return 'http://dynamic.t0.tiles.ditu.live.com/comp/ch/' + a + '?it=G,VE,BX,L,LA&mkt=zh-cn,syr&n=z&og=111&ur=CN'
    }
  }
}
</script>

<style lang="less" scoped>
.span-icon {
  width: 8px;
  height: 8px;
  border-radius: 4px;
  margin-top: 7px;
  margin-left: 8px;
  background-color: #0a0a0a;
}

/deep/ .ant-select-selection--single {
  height: 36px;
  color: #ffffff;
  background: rgb(0, 32, 54);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

/deep/ .ant-select-arrow {
  color: #fff;
}

/deep/ .ant-select-selection-selected-value .anticon-check {
  display: none;
}

/deep/ .ant-select-dropdown-menu-item {
  display: flex !important;
}
</style>
